__turbopack_context__.v({
  "body": "CrmVendorSection-module__FRz90q__body",
  "cta": "CrmVendorSection-module__FRz90q__cta",
  "eyebrow": "CrmVendorSection-module__FRz90q__eyebrow",
  "figure": "CrmVendorSection-module__FRz90q__figure",
  "imageWrap": "CrmVendorSection-module__FRz90q__imageWrap",
  "item": "CrmVendorSection-module__FRz90q__item",
  "list": "CrmVendorSection-module__FRz90q__list",
  "logoMark": "CrmVendorSection-module__FRz90q__logoMark",
  "section": "CrmVendorSection-module__FRz90q__section",
  "title": "CrmVendorSection-module__FRz90q__title",
});
